import React, { forwardRef } from 'react';
import { Form, Upload, Icon } from 'antd';
import { filedNames } from '../../constants';

const maxFileSize = 15728640;

export const validator = (_, value, callback) => {
  if (Boolean(value?.length)) {
    const hasBigFiles = value.some((file) => file.size > maxFileSize);
    return callback(hasBigFiles ? 'Выделенные файлы весят больше 15 Мб' : undefined);
  }

  callback();
};

const UploadDragger = forwardRef(({ onChange, ...props }, ref) => {
  const handleChange = (info) => {
    const file = info.file;
    let fileList = info.fileList;

    if (file.size > maxFileSize) {
      fileList = fileList.map((el) => {
        if (el.uid === file.uid) {
          el.status = 'error';
        }
        return el;
      });
    }

    onChange(fileList);
  };

  return (
    <Upload.Dragger
      {...props}
      multiple
      beforeUpload={() => false}
      onChange={handleChange}
    >
      <Icon
        type="file-add"
        theme="outlined"
      />{' '}
      перетащите файлы сюда или нажмите, чтобы выбрать
      <br />
      Максимальный размер файла - 15 Мб
    </Upload.Dragger>
  );
});

const UploadFilesField = ({ form }) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item
      label="Добавить вложения"
      colon={false}
    >
      {getFieldDecorator(filedNames.files, {
        valuePropName: 'fileList',
        initialValue: [],
        rules: [{ validator }],
      })(<UploadDragger />)}
    </Form.Item>
  );
};

export default UploadFilesField;
